import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BaseService } from '../../../base.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService extends BaseService  {
  
  
  constructor(http: HttpClient,) {
    super(http);
  }

  private loginUrl =  this.BASEURL + '/api/Auth/Login';
  
  login(body:any): Observable<any> {

    console.log("🚀 > LoginService > login > body:", body)
    return this.http.post(this.loginUrl, body);
  }

  loginEncrypted(email: string): Observable<any> {
    // const url = this.BASEURL + '/api/Auth/x2xLoginWithEmailOnly?EmailAddress_Enc=' + encodeURIComponent(email);
    const url = this.BASEURL + '/api/Auth/x2xLoginWithEmailOnly?EmailAddress_Enc=' + email;
    return this.http.get(url);
  }

  sendResetLink(email:any): Observable<any> {
    return this.http.get(this.BASEURL + '/api/Auth/ForgotPassword?EmailAddr='+ email);
  }

  override getIntuitConnectURL(): Observable<any> {
    return this.http.get(this.QBBaseURL + 'Intuit/GetClientConnectURL');
  }
}
